export default __webpack_public_path__ + "static/media/ic_cad.bf8fb0b1.svg";